import React from 'react';
import { Hero } from './components/Hero';
import { ProofBar } from './components/ProofBar';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { WhatYouGet } from './components/WhatYouGet';
import { Gallery } from './components/Gallery';
import { Comparison } from './components/Comparison';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { PurchaseToast } from './components/PurchaseToast';
import { useMetaPixel } from './hooks/useMetaPixel';
interface AppProps {
  showUrgency?: boolean;
  showPurchaseNotifications?: boolean;
}
export function App({
  showUrgency = true,
  showPurchaseNotifications = false
}: AppProps) {
  useMetaPixel();
  return <div className="w-full bg-white text-slate-900 antialiased" data-id="element-0" data-mp="3ikh7o8icgqyg">
      <main data-id="element-1" data-mp="3ihuyy5jpw5en">
        <Hero data-id="element-2" data-mp="3mlj8gtrwtb2j" />
        <ProofBar data-id="element-3" data-mp="3ml14faz09sk2" />
        <Problem data-id="element-4" data-mp="3mkhmhu9cv461" />
        <Gallery data-id="element-5" data-mp="3mjzs7369700r" />
        <Solution data-id="element-6" data-mp="3mjgannkimdn9" />
        <WhatYouGet data-id="element-7" data-mp="3rc9e8848zfxr" />
        <Comparison data-id="element-8" data-mp="3rbrbqtqzs5he" />
        <Bonuses data-id="element-9" data-mp="3rdatypw7kqlt" />
        <Pricing showUrgency={showUrgency} data-id="element-10" data-mp="3rcsuzli5vya7" />
        <Testimonials data-id="element-11" data-mp="5orh0l86u6j" />
        <Guarantee data-id="element-12" data-mp="4wvvprmowg9" />
        <Faq data-id="element-13" data-mp="5gfrc0u9uwx" />
        <FinalCta showUrgency={showUrgency} data-id="element-14" data-mp="56qjqnmbrsa" />
      </main>
      <Footer data-id="element-15" data-mp="2zlv8iz6e19x6" />
      {showPurchaseNotifications && <PurchaseToast data-id="element-16" data-mp="2zn6biws0edn8" />}
    </div>;
}